import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbColorPicker } from "abreact/misc/AbColorPicker";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import * as React from "react";
export function AbColorDataValueInput(props) {
  const viewModel = AbFormHooks.useDataValueInputViewModel("ab-color-data-value-input", props);
  if (!viewModel) {
    return null;
  }
  const currentValue = viewModel.currentValue;
  const onChange = newColor => {
    if (newColor === viewModel.currentValue) {
      viewModel.changeValue(null);
      return;
    }
    viewModel.changeValue(newColor !== "" ? newColor : null);
  };

  // Render as inactive if the component is editable and being shown in edit mode, but yet it isn't editing.
  // This means that the user is trying to edit the data value, but they don't have editing permissions.
  const isInactive = !viewModel.isEditing && !props.readOnly && viewModel.isInEditMode;
  const tooltip = viewModel.inputProps.tooltip ?? currentValue ?? AbWebResources.undefined_boolean_tooltip();
  return !viewModel.isEditing ? /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, viewModel.readOnlyProps, {
    subject: props.subject,
    accessor: props.accessor,
    currentValue: currentValue,
    inactive: isInactive
  })) : /*#__PURE__*/React.createElement("div", {
    className: viewModel.inputProps.className,
    id: viewModel.inputProps.id,
    "data-test-id": viewModel.inputProps.dataTestId,
    style: viewModel.inputProps.style
  }, /*#__PURE__*/React.createElement(AbColorPicker, _extends({}, viewModel.inputProps, {
    disabled: true,
    showBackgroundColorOnDisabled: true,
    showBlackBackgroundColor: true,
    tooltip: tooltip,
    icon: currentValue == null ? "absdk:forbidden-cursor" : "absdk:transparent",
    value: currentValue ?? "",
    onChange: onChange
  })));
}
//# sourceMappingURL=AbColorDataValueInput.js.map
